export default __webpack_public_path__ + "static/media/carta.a1481bfb.png";